import {
  Box,
  Divider,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { MailIcon } from "@/components/common/icons";
import {
  GREY,
  TEXT_DISABLED,
  TEXT_PRIMARY_DARK,
  TEXT_SECONDARY,
  VIOLET,
} from "@/config/mui/colorPalette";

export default function EditClientCommsItem({
  disabled,
  communicationStatusText,
  openModal,
  showDivider = true,
}: {
  disabled: boolean;
  communicationStatusText: string;
  openModal: () => void;
  showDivider?: boolean;
}) {
  return (
    <Box>
      <Typography
        variant="labelTiny"
        sx={{
          color: TEXT_SECONDARY,
        }}
      >
        Client communication
      </Typography>

      <ListItemButton
        onClick={openModal}
        disabled={disabled}
        sx={{
          backgroundColor: GREY[5],
          borderRadius: 2,
          gap: 1,
        }}
      >
        <MailIcon color={GREY[60]} size={24} />
        <ListItemText
          sx={{
            m: 0,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          primary={communicationStatusText}
          secondary="Edit"
          slotProps={{
            primary: {
              variant: "labelSmall",
              color: disabled ? TEXT_DISABLED : TEXT_PRIMARY_DARK,
            },
            secondary: {
              variant: "labelSmall",
              color: disabled ? TEXT_DISABLED : VIOLET[90],
            },
          }}
        />
      </ListItemButton>
      {showDivider && <Divider variant="fullWidth" sx={{ my: 2 }} />}
    </Box>
  );
}
